/* rs-cart-badge.js - header bag-count reconciliation, loaded by snippets/header.toggle-cart.liquid.
   launch readiness pass 2, 2026-09-24: moved out of the inline <script> and loaded with `defer`. The fetch/XMLHttpRequest hooks are
   therefore installed at end-of-parse instead of at header parse; the cart writes this watches come from user
   actions or from app scripts that boot after DOMContentLoaded, and the `pageshow` refresh below still reconciles
   the badge once after load regardless. */
/* RS: guarantee the header bag count reflects the true cart after any
   add / quantity change. The theme's built-in updater relies on a
   'cart-ajax' section fragment being present on the event payload; when it
   isn't, the badge silently goes stale even though the item was added.
   This reads the authoritative count from /cart.js on the same events. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function setBadge(n) {
    n = parseInt(n, 10) || 0;
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      var num = b.querySelector('.cart-link__bubble-num');
      if (num) num.textContent = n;
      b.classList.toggle('cart-link__bubble--visible', n > 0);
    });
  }
  var t = null;
  function refresh() {
    clearTimeout(t);
    // small delay so /cart.js reflects the completed add
    t = setTimeout(function () {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { setBadge(c.item_count); })
        .catch(function () {});
    }, 60);
  }
  /* rs:cart-reconcile = assets/rs-free-gift.js added or removed a free packet */
  ['ajaxProduct:added', 'cart:updated', 'rs:cart-reconcile'].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });

  /* RS: reconcile after cart changes that raise no theme event. The Kite
     free-gift app writes the cart through the STOREFRONT API
     (POST /api/.../graphql.json), not /cart/*.js, and then tries to refresh
     the count by re-rendering Dawn's `cart-icon-bubble` section -- which this
     theme does not have, so its refresh is a silent no-op and the badge goes
     stale (verified: cart emptied to 0 while the badge still read 1). Watch
     fetch/XHR for cart-mutating traffic and re-read /cart.js once it lands.
     Also reconcile when the tab is re-shown, so a change made in another tab
     (or a gift Kite pulls while the tab is backgrounded) cannot leave a wrong
     number on screen. */
  if (!window.__rsBadgeWatch) {
    window.__rsBadgeWatch = true;
    var CART_WRITE = /\/cart\/(add|change|update|clear)|cart-icon-bubble|graphql\.json/i;
    var nativeFetch = window.fetch;
    if (nativeFetch) {
      window.fetch = function (input) {
        var p = nativeFetch.apply(this, arguments);
        try {
          var u = (input && input.url) || input;
          /* refresh only once the write has landed, so /cart.js is current */
          if (u && CART_WRITE.test(String(u))) p.then(refresh, function () {});
        } catch (e) {}
        return p;
      };
    }
    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (url && CART_WRITE.test(String(url))) this.addEventListener('loadend', refresh);
      } catch (e) {}
      return nativeOpen.apply(this, arguments);
    };
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    });
    window.addEventListener('pageshow', refresh);
  }
})();
